export default "__VITE_PUBLIC_ASSET__58396453__"